import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Grid,
} from '@mui/material';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { parseISO } from 'date-fns';
import { SocketAlarm } from '../spectrasWebSocketServer/types';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { FiberManualRecord } from '@mui/icons-material';
import { formatInTimeZone } from 'date-fns-tz';

interface Props {
  alarm: SocketAlarm;
  index: number;
  handleAlarmClicked: (alarm: SocketAlarm) => void;
  handleAlarmDeleted: (index: number) => void;
}

const NotificationAlarmListItem = ({
  alarm,
  index,
  handleAlarmClicked,
  handleAlarmDeleted,
}: Props) => {
  const { dateFormatWithZeros, timeFormat, timezone } = useUserDateTime();
  const formattedDateTime = formatInTimeZone(
    parseISO(alarm.timestamp),
    timezone,
    `${dateFormatWithZeros} ${timeFormat}`
  );

  return (
    <ListItem button onClick={() => handleAlarmClicked(alarm)}>
      <ListItemText secondary={formattedDateTime}>
        <Grid container alignItems='center'>
          {alarm.name}
          <FiberManualRecord
            fontSize='small'
            sx={{ height: '15px', color: 'red' }}
          />
        </Grid>
      </ListItemText>
      <ListItemSecondaryAction>
        <IconButton
          edge='end'
          aria-label='delete'
          onClick={() => handleAlarmDeleted(index)}
          size='large'
        >
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default NotificationAlarmListItem;
